const InstructorSettings = () => {
  return (
    <div className="main-dash-content">
      <div className="main-dash-template">
        <header>
          <h1>Settings</h1>
        </header>
      </div>
    </div>
  );
};

export default InstructorSettings;
